import _CalendarIcon from "@adsk/alloy-react-icon/es/lib/CalendarIcon";
const _excluded = ["variant", "value"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import Button from '@adsk/alloy-react-button';
import Field from './Field';
import { DATE_PICKER_VARIANTS } from '../consts';
const renderIcon = p => /*#__PURE__*/React.createElement(_CalendarIcon, p);
const Trigger = _ref => {
  let {
      variant,
      value
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (variant === DATE_PICKER_VARIANTS.ICON) {
    return /*#__PURE__*/React.createElement(Button, _extends({
      renderIcon: renderIcon
    }, rest));
  }
  return /*#__PURE__*/React.createElement(Field, _extends({
    value: value
  }, rest));
};
Trigger.displayName = 'DatePickerTrigger';
Trigger.propTypes = {
  /** Variant of the field could be icon or field */
  variant: PropTypes.oneOf(Object.values(DATE_PICKER_VARIANTS))
};
export default Trigger;
//# sourceMappingURL=Trigger.js.map